/** @ngInject */
export default function runBlock(authService) {
	const revived = authService.reviveSession()

	if (!revived) {
		authService.login()
	}
}
